import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProjectsWithFiltersComponent } from '@app/components/projects-with-filters/projects-with-filters.component';

@Component({
  selector: 'app-admin-project-list',
  imports: [ProjectsWithFiltersComponent],
  templateUrl: './project-list.component.html',
  styleUrl: './project-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminProjectListComponent {}
